import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EfCardCommon from '@elem/ui/ef-card-common';
import styles from './index.module.scss';

import { useProductStore } from '../../../ProductProvider';
import { IPageStatus } from '../../../config/IPageStatus';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const { locale } = getLocal();
    const { pageStatus } = useProductStore();

    const InfoData_eu = {
        theme: 'black',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725420837418/product_1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725420973371/product_1_h5.jpg',
        label: t('dp3_banner_label'),
        title: t('dp3_banner_title'),
        desc: t('dp3_banner_desc'),
        moreLink: `https://www.ecoflow.com/${locale}/delta-pro-3-portable-power-station`,
        moreText: t('dp3_banner_btn_1'),
        buyLink: `https://${locale}.ecoflow.com/products/delta-pro-3-portable-power-station`,
        buyText: t('dp3_banner_btn_2_status_B'),
    };

    const InfoData_uk = {
        theme: 'black',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725421279536/product_1_uk.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725421279361/product_1_h5_uk.jpg',
        label: t('dp3_banner_label'),
        title: t('dp3_banner_title'),
        desc: t('dp3_banner_desc'),
        buyLink: `https://${locale}.ecoflow.com/products/delta-pro-3-portable-power-station`,
        buyText: pageStatus === IPageStatus.statusB ? t('dp3_banner_btn_2_status_B') : t('dp3_banner_btn_2'),
    };

    const finalInfoData = locale === 'uk' ? InfoData_uk : InfoData_eu;

    return (
        <div className={styles.TheComp} id="full-a-box">
            <EfCardCommon isCloseGloCardLink={true} gtm_position="Product Preview" {...finalInfoData} />
        </div>
    );
}
